import * as Yup from 'yup';

const PUCLoginSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Required'),
  password: Yup.string()
    .min(8, 'Password must contain at least 8 characters')
    .required('Please enter your password'),
});
export default PUCLoginSchema;
